import React, { Component } from "react";
import getCancelToken from "../../../Helpers/GetCancelToken";
import getNestedObject from "../../../Helpers/GetNestedObject";
import Loader from "../../../Common/Components/Loader/Loader";
import { RenderText } from "../../../Forms/forms";
import ReactTable from "react-table";
import { Check } from "react-feather";
import { Field } from "redux-form";
import { translate } from "react-i18next";
import PropTypes from "prop-types";
import EditDictionaryField from "../Helpers/EditDictionaryField";
import ACTION_TYPES from "../../../Enums/ActionTypes";

class CoursesModes extends Component {
  static propTypes = {
    fetchDictionary: PropTypes.func,
    initialValues: PropTypes.object,
    initialize: PropTypes.func,
    values: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    t: PropTypes.func,
    updateDictionary: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.cancelToken = getCancelToken();
    const { fetchDictionary } = this.props;

    this.state = { coursesModes: [] };

    fetchDictionary(this.cancelToken, {
      path: "/course/mode",
      actionType: ACTION_TYPES.FETCH_COURSES_MODES,
    });

    this.renderEditField = this.renderEditField.bind(this);
    this.updateModesDictionary = this.updateModesDictionary.bind(this);
  }

  componentWillUnmount() {
    this.cancelToken.cancel();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      initialValues: { coursesModes },
      initialize,
    } = this.props;

    if (coursesModes !== nextProps.initialValues.coursesModes) {
      this.setState({ coursesModes: nextProps.initialValues.coursesModes });
      initialize(nextProps.initialValues);
    }
  }

  enableEditMode(row) {
    const { coursesModes } = this.state;

    !coursesModes[row.index].editMode
      ? (coursesModes[row.index].editMode = [])
      : null;
    !coursesModes[row.index].editMode.includes(row.column.id) &&
      coursesModes[row.index].editMode.push(row.column.id);

    this.setState({ coursesModes });
  }

  renderEditField(row) {
    const { coursesModes } = this.state;
    const value = getNestedObject(this.props.values[row.index], row.column.id);

    return (
      <div className="editField">
        {coursesModes[row.index] &&
        coursesModes[row.index].editMode &&
        coursesModes[row.index].editMode.indexOf(row.column.id) >= 0 ? (
          <div className="dictionary-text__input">
            <Field
              value={value}
              name={`coursesModes[${row.index}][${row.column.id}]`}
              component={RenderText}
            />
            <div
              onClick={() =>
                this.updateModesDictionary(row.index, row.column.id)
              }
              className="dictionary-text__button"
            >
              <Check size={23} />
            </div>
          </div>
        ) : (
          <EditDictionaryField
            onClick={() => this.enableEditMode(row)}
            text={value}
          />
        )}
      </div>
    );
  }

  updateModesDictionary(index, modeId) {
    const {
      values,
      initialValues,
      updateDictionary,
      fetchDictionary,
    } = this.props;
    const { coursesModes } = this.state;
    const arraySpot = coursesModes[index].editMode.findIndex(
      element => element === modeId,
    );

    coursesModes[index].editMode.splice(arraySpot, 1);
    this.setState({ coursesModes });

    if (
      values &&
      values[index][modeId] !== initialValues.coursesModes[index][modeId]
    ) {
      const updates = { name: values[index].name };

      updateDictionary(`/course/mode/${values[index].id}`, updates, () => {
        fetchDictionary(this.cancelToken, {
          path: "/course/mode",
          actionType: ACTION_TYPES.FETCH_COURSES_MODES,
        });
      });
    }
  }

  render() {
    const {
      initialValues: { coursesModes },
      values,
      t,
    } = this.props;

    return coursesModes.length === 0 ? (
      <Loader />
    ) : (
      <div className="fade-in">
        <ReactTable
          noDataText={t("No records found")}
          data={values}
          columns={[
            {
              Header: t("No."),
              accessor: "id",
              Cell: row => <span>{row.index + 1}.</span>,
              resizable: false,
              width: 50,
            },
            {
              Header: t("NameItem"),
              accessor: "name",
              Cell: this.renderEditField,
            },
          ]}
          defaultPageSize={10}
          showPagination={true}
        />
      </div>
    );
  }
}

export default translate()(CoursesModes);
